import { useCallback, useState, useEffect } from "react";
import { useGoogleLoader } from "../components/GoogleLoaderProvider.js";
const useAutocomplete = () => {
  const [autocompleteService, setAutocomplete] = useState(void 0), loader = useGoogleLoader();
  return useEffect(() => {
    loader == null || loader.importLibrary("places").then(({ AutocompleteService: AutocompleteService2 }) => {
      const autocomplete = new AutocompleteService2();
      setAutocomplete(autocomplete);
    });
  }, [loader]), { autocompleteService };
}, SEARCH_COUNTRY = "us", googleAutocompleteOptions = {
  strictBounds: !1,
  componentRestrictions: { country: SEARCH_COUNTRY }
}, useGoogleAutocomplete = () => {
  const { autocompleteService } = useAutocomplete();
  return { search: useCallback(
    async (input) => {
      const { predictions } = await (autocompleteService == null ? void 0 : autocompleteService.getPlacePredictions({
        input,
        ...googleAutocompleteOptions
      })) ?? { predictions: [] };
      return predictions;
    },
    [autocompleteService]
  ) };
};
export {
  SEARCH_COUNTRY,
  googleAutocompleteOptions,
  useGoogleAutocomplete
};
//# sourceMappingURL=useGoogleAutocomplete.js.map
